<section>
  <div>
    <div class="row align-items-center mx-0 p-1">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <h6 class="m-0">
          {{ isFormView ? 'Registrar detalle de pedido internos' : 'Detalle de pedido internos' }}
        </h6>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end gap-2">
        @if (swQuotation) {
        <app-custom-button [label]="'Artículos Cotizados'" [title]="'Artículos Cotizados'" [severity]="'success'"
          [disabled]="disabledButton" [width]="'9rem'" (onClick)="openQuotationModal()"></app-custom-button>
        }
        <app-custom-modal #quotationModal [header]="'Artículos Cotizados'" [children]="componentFromQuotation"
          [inputs$]="inputsForQuotationModal$" (params)="reloadFromQuotation($event)" hidden></app-custom-modal>
        <app-custom-modal #articleType [label]="'Nuevo Detalle'" [header]="'Selección de Insumos'"
          [children]="component" [inputs$]="inputsForArticlesByTypes$" [output$]="output$" [disabled]="disabledButton"
          (selectedItems)="handleSelectedItems($event)" hidden></app-custom-modal>
        <app-custom-button tom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disabledButton"
          (onClick)="openModal()" [width]="'7rem'"></app-custom-button>
      </div>
    </div>
    <div class="row border mx-0" [hidden]="!isFormView">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-1">
        <app-register-internal-order-detail [internalOrderDetailContract]="internalOrderDetail"
          [internalOrderContract]="internalOrderModel" [newArticlesDetail]="newArticlesDetail"
          [disabled]="disabledDetail" (updateListDetail)="getInternalOrderDetailsByInternalOrder()"
          (isFormView)="getFormView($event)">
        </app-register-internal-order-detail>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-1">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [showCheckbox]=" !this.disabledButton " [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getInternalOrderDetailsByInternalOrder()"
        (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>